/**
 * description: 描述信息
 * author: bql
 * 2023/6/28 11:06
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class DataApproveInfoApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'data-approve-info'
    }

}